import { render, staticRenderFns } from "./Artwork.vue?vue&type=template&id=8c81b476&scoped=true"
import script from "./Artwork.vue?vue&type=script&lang=js"
export * from "./Artwork.vue?vue&type=script&lang=js"
import style0 from "./Artwork.vue?vue&type=style&index=0&id=8c81b476&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c81b476",
  null
  
)

export default component.exports